import { inject, injectable } from 'inversify'
import * as Api from '@xlearn/common';
import { PlayerModule } from '../api'
import { BadgeService, BadgeServiceSymbol } from './service'
import { replaceBasePathInContent } from '../shared/utils/base-path';

@injectable()
export class BadgePlayerModule implements PlayerModule {

  readonly name = 'badge'
  
  constructor(
    @inject(BadgeServiceSymbol)
    private badgeService: BadgeService) {}

  start(instance: Api.SerializedAspectInstance): void {
    this.badgeService.start(this.resolveBadgeSource(instance));
  }

  reset(instance: Api.SerializedAspectInstance): void {
    this.badgeService.reset(this.resolveBadgeSource(instance));
   }

  async stop() {
    await this.badgeService.stop()
  }

  private resolveBadgeSource(instance: Api.SerializedAspectInstance) {
    const badgeUri = replaceBasePathInContent(instance.basePath)(instance.details.files.badgesUri);
    const source = badgeUri ? { uri: badgeUri, basePath: instance.basePath } : null;
    return source;
  }
}
